import React, {Component} from 'react';
import {connect} from 'react-redux'
import {withRouter} from "react-router-dom";
import {Timeline, TimelineEvent} from 'react-event-timeline';
import {Button} from '@material-ui/core';
import dateUtil from "../../../../../util/dateUtil";
import {constStatus} from "../../../../../constants";
import {bindActionCreators} from "redux";
import ReduxMission from "../../../../../store/actionreducers/mission";
import ReduxGlobal from "../../../../../store/actionreducers/globalView";
import Status from "../../../../../constants/status";


// progress 參考資料 : https://www.npmjs.com/package/react-event-timeline
class ProgressAndActionTab extends Component {

    state = {
        actionType: 'view', // view . add . edit
    };

    handleButtonOnClick({event, func, messageType}) {

        const {mission, getMission, openAlertDialog, openLoadingMask, closeLoadingMask} = this.props;

        const messageTypes = {
            openChatRoom: {
                title: '開啟諮詢室',
                message: '請問您確定要開啟此任務的諮詢室嗎?'
            },
            failMission: {
                title: '任務失敗',
                message: '請問您確定此任務失敗嗎?'
            },
            finishMission: {
                title: '完成任務',
                message: '請問您確定要完成此任務嗎?'
            },
            cancelMission: {
                title: '任務取消',
                message: '請問您確定此任務取消嗎?'
            },
        };

        event.stopPropagation();

        const alertDialogInfo = {
            title: messageTypes[messageType].title,
            message: messageTypes[messageType].message,
            yesButton: {
                label: '是',
                onClick: async () => {
                    try {
                        openLoadingMask();
                        await func(mission.id);
                        await getMission(mission.id);
                        closeLoadingMask();
                    } catch (e) {
                        console.warn('you got an error = ', e);
                    }
                },
            },
            noButton: {label: '否'}
        };

        openAlertDialog(alertDialogInfo);
    }

    renderProgresses(progresses = []) {

        return progresses.map((progress, index) => {

            const title = dateUtil.format({date: progress.time, formatPattern: 'YYYY-MM-DD HH:mm:ss'});

            if (progress.active_count !== 0) {
                return (
                    <TimelineEvent
                        key={index}
                        title={title}
                        icon={<i className="material-icons md-18">lens</i>}
                        iconColor="#6fba1c"
                        subtitle={progress.content}
                        container="card"
                        titleStyle={{fontSize: 16, fontWeight: 'bold'}}
                        subtitleStyle={{fontSize: 16, color: "#ff3475", fontWeight: 'bold'}}
                    />
                );
            } else {
                return (
                    <TimelineEvent
                        key={index}
                        title={title}
                        icon={<i className="material-icons md-18">panorama_fish_eye</i>}
                        iconColor="#6fba1c"
                        subtitle={progress.content}
                        titleStyle={{fontSize: 16, fontWeight: 'bold'}}
                        subtitleStyle={{fontSize: 16, color: "#2962FF", fontWeight: 'bold'}}
                    />
                );
            }
        });
    }

    render() {
        const {mission, failMission, finishMission, openChatRoom, cancelMission} = this.props;
        const EMERGENCY_MEDICAL_CONSULT_ID = 1
        return (
            <div className="flex flex-1 flex-row">
                <div className="flex flex-1 justify-center">
                    <Timeline>
                        {this.renderProgresses(mission.temp.progresses)}
                    </Timeline>
                </div>
                <div className="flex flex-1 flex-col lg:items-end">
                    <Button variant="contained" color="primary" className='m-4 lg:w-1/4'
                            disabled={mission.status.label !== constStatus.reserved.label}
                            onClick={(event) => {
                                this.handleButtonOnClick({event, func: openChatRoom, messageType: 'openChatRoom'});
                            }}>
                        開啟諮詢室
                    </Button>
                    <Button variant="contained" disabled color="secondary"
                            className='m-4 lg:w-1/4 bg-pink hover:bg-pink-dark'>
                        進入諮詢室
                    </Button>
                    <Button variant="contained" color="primary" className='m-4 lg:w-1/4 bg-green hover:bg-green-dark'
                            disabled={mission.status.label !== constStatus.chatRoomReadied.label}
                            onClick={(event) => {
                                this.handleButtonOnClick({event, func: finishMission, messageType: 'finishMission'});
                            }}>
                        完成任務
                    </Button>
                    {mission.type.id === EMERGENCY_MEDICAL_CONSULT_ID ? ( 
                    <Button variant="contained" color="secondary" className='m-4 lg:w-1/4'
                            disabled={!mission.can_fail}
                            onClick={(event) => {
                                this.handleButtonOnClick({event, func: failMission, messageType: 'failMission'});
                            }}>
                        任務失敗
                    </Button>
                    )
                    :
                    <Button variant="contained"  className='m-4 lg:w-1/4'
                            color="secondary"
                            disabled={!mission.can_fail || mission.status.label === Status.finding.label || mission.status.label === Status.cancelled.label}
                            onClick={(event) => {
                                this.handleButtonOnClick({event, func: cancelMission, messageType: 'cancelMission'});
                            }}>
                        任務取消
                    </Button>}
                </div>
            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        failMission: ReduxMission.ActionCreator.failByAdminMedical,
        openChatRoom: ReduxMission.ActionCreator.openChatRoomByAdminMedical,
        finishMission: ReduxMission.ActionCreator.finishByAdminMedical,
        cancelMission: ReduxMission.ActionCreator.cancelByAdminMedical,
        getMission: ReduxMission.ActionCreator.getInstitutionMission,
        openAlertDialog: ReduxGlobal.ActionCreator.openAlertDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch);
}

function mapStateToProps({mission}) {

    return {
        progresses: mission.progresses,
        mission
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProgressAndActionTab));



// WEBPACK FOOTER //
// ./src/main/content/adminMedical/mission/tabs/ProgressAndActionTab.js